"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Label = _interopRequireDefault(require("../Label/Label.js"));

var _Tooltip = _interopRequireDefault(require("./Tooltip.style"));

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let Tooltip = (_dec = (0, _reactJss.default)(_Tooltip.default), _dec(_class = class Tooltip extends _react.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      position: {
        left: 0,
        top: 0
      },
      side: null,
      arrowSize: 6,
      tooltip: false,
      parentNodePosition: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }
    };
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  showTooltip(e) {
    const {
      value
    } = this.props;
    if (!value) return;
    this.debaunce = true;
    const el = e.target;
    this.setState({
      tooltip: true
    });
    setTimeout(() => {
      if (!this.debaunce || !this._isMounted) return;
      this.debaunce = false;
      this.setTooltipPosition(el);
    }, 200);
  }

  hideTooltip() {
    const {
      hideDelay
    } = this.props;
    setTimeout(() => {
      this.debaunce = false;
      this.setState({
        tooltip: false
      });
    }, hideDelay);
  } // set tooltip position


  setTooltipPosition(parEl) {
    const pointPar = this.getParentPoints(parEl);
    const posTooltip = this.getPosTooltip(pointPar);
    const side = this.getSide(posTooltip);
    this.setState({
      position: {
        left: `${posTooltip[side].left}px`,
        top: `${posTooltip[side].top}px`
      },
      side
    });
  } // calculate parent's node center points for each side


  getParentPoints(target) {
    const {
      left,
      top,
      width,
      height
    } = target.getBoundingClientRect();
    const {
      parentNodePosition
    } = this.state;
    return {
      top: {
        x: left + width / 2 - parentNodePosition.left,
        y: top + parentNodePosition.top
      },
      left: {
        x: left - parentNodePosition.left,
        y: top - parentNodePosition.top + height / 2
      },
      right: {
        x: left - parentNodePosition.left + width,
        y: top - parentNodePosition.top + height / 2
      },
      bottom: {
        x: left - parentNodePosition.left + width / 2,
        y: top - parentNodePosition.top + height
      }
    };
  } // calculate tooltip position relative to parent node


  getPosTooltip(pointPar) {
    const arrow = this.state.arrowSize;
    return {
      bottom: {
        left: pointPar.bottom.x - this.el.offsetWidth / 2,
        top: pointPar.bottom.y + arrow
      },
      top: {
        left: pointPar.top.x - this.el.offsetWidth / 2,
        top: pointPar.top.y - arrow - this.el.offsetHeight
      },
      left: {
        left: pointPar.left.x - arrow - this.el.offsetWidth,
        top: pointPar.left.y - this.el.offsetHeight / 2
      },
      right: {
        left: pointPar.right.x + arrow,
        top: pointPar.right.y - this.el.offsetHeight / 2
      }
    };
  } // calculate best side for display tooltip


  getSide(posTooltip) {
    const {
      parentNodePosition
    } = this.state;
    const heightTooltip = this.el.offsetHeight;
    const widthTooltip = this.el.offsetWidth;
    const heightWindow = window.innerHeight;
    const widthWindow = window.innerWidth;
    const arrow = this.state.arrowSize;

    if (posTooltip.bottom.left + parentNodePosition.left > 0 && posTooltip.bottom.left + parentNodePosition.left + widthTooltip < widthWindow && posTooltip.bottom.top + parentNodePosition.top + heightTooltip + arrow < heightWindow) {
      return 'bottom';
    } else if (posTooltip.right.left + parentNodePosition.left + widthTooltip + arrow < widthWindow) {
      return 'right';
    } else if (posTooltip.left.left - arrow + parentNodePosition.left > 0) {
      return 'left';
    }

    return 'top';
  }

  renderTip() {
    const {
      classes,
      className,
      value,
      size
    } = this.props;
    const {
      side,
      position,
      tooltip
    } = this.state;
    const classNames = (0, _clsx.default)(className, classes.tooltip, classes[size], classes[`${side}Side`], {
      [classes.active]: tooltip && position.top !== '0'
    }); // убирать со страници после окончания анимации закрытия

    if (position.left !== '-100000px' && position.top !== '0' && !tooltip) {
      setTimeout(() => {
        if (!this._isMounted) return;
        this.setState({
          position: {
            left: '-100000px',
            top: '0'
          }
        });
      }, 200);
    }

    if (!tooltip) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: el => this.el = el,
      className: classNames,
      style: {
        left: position.left,
        top: position.top
      },
      onClick: this.onClick
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      value: value,
      className: (0, _clsx.default)(classes.text)
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.arrow, classes[side])
    }));
  }

  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, _react.default.Children.map(children, child => _react.default.cloneElement(child, {
      onMouseEnter: this.showTooltip,
      onMouseLeave: this.hideTooltip
    })), _reactDom.default.createPortal(this.renderTip(), document.body));
  }

}) || _class);
Tooltip.defaultProps = {
  size: 'medium',
  hideDelay: 0
};
var _default = Tooltip;
exports.default = _default;